module.exports = __webpack_public_path__ + "img/img-login-bg.01c14f04.jpg";